export function initBanner() {
    const boxes = document.querySelectorAll(".banner-container")

    boxes.forEach(function(box) {
        let banner_type = box.getAttribute('data-type');
        let banner_block = box.parentNode;
        banner_block.classList.add("box-banner" + banner_type );
    });
}